export enum OnKeyPressEnum {
	Escape = "Escape",
	ArrowLeft = "ArrowLeft",
	ArrowRight = "ArrowRight",
}
